import { render } from "./EligibilityNotice.vue?vue&type=template&id=244742aa&scoped=true"
import script from "./EligibilityNotice.vue?vue&type=script&lang=js"
export * from "./EligibilityNotice.vue?vue&type=script&lang=js"

import "./EligibilityNotice.vue?vue&type=style&index=0&id=244742aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244742aa"]])

export default __exports__